import { render } from "./GuiDiscountTypeSelect.vue?vue&type=template&id=42f420c0"
import script from "./GuiDiscountTypeSelect.vue?vue&type=script&lang=js"
export * from "./GuiDiscountTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__